var _g, _g2, _path, _g3, _g4, _path2, _g5, _g6, _g7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorial3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 301,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tutorial_3_svg__filter0_d_116_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.764 15.273a8.983 8.983 0 01-2.45-.335c-.782-.233-1.411-.532-1.888-.897l.837-1.857c.457.335 1 .604 1.629.807a6.117 6.117 0 001.887.304c.7 0 1.217-.102 1.552-.304.335-.214.502-.493.502-.838a.764.764 0 00-.304-.623 2.085 2.085 0 00-.761-.411c-.304-.102-.72-.213-1.248-.335a17.337 17.337 0 01-1.994-.579 3.297 3.297 0 01-1.339-.928C.822 8.851.64 8.283.64 7.573c0-.62.168-1.177.502-1.675.335-.507.837-.908 1.507-1.202.68-.294 1.507-.441 2.48-.441.68 0 1.345.081 1.994.243a5.89 5.89 0 011.705.7L8.066 7.07c-.984-.558-1.968-.837-2.952-.837-.69 0-1.203.112-1.538.335-.324.223-.487.518-.487.883s.188.639.564.822c.385.172.968.345 1.75.517.811.193 1.476.386 1.993.578.518.193.96.498 1.324.913.376.416.564.98.564 1.69 0 .609-.173 1.167-.518 1.674-.335.497-.842.893-1.522 1.187-.68.294-1.506.441-2.48.441zm14.453-2.16v1.978h-8.249V4.437h8.051v1.979h-5.6v2.313h4.946v1.918h-4.946v2.465h5.798zm8.75 1.978l-2.055-2.968h-2.268v2.968h-2.465V4.437h4.61c.944 0 1.761.158 2.451.472.7.315 1.238.761 1.613 1.34.376.578.563 1.263.563 2.054 0 .791-.192 1.476-.578 2.055-.375.568-.913 1.004-1.613 1.308l2.39 3.425h-2.649zm-.046-6.788c0-.599-.193-1.055-.579-1.37-.385-.324-.948-.487-1.69-.487h-2.008v3.714h2.009c.74 0 1.304-.163 1.69-.487.385-.325.578-.781.578-1.37zm14.691-3.866l-4.611 10.654h-2.435L30.97 4.437h2.663l3.242 7.61 3.287-7.61h2.45zm9.138 8.675v1.979h-8.248V4.437h8.05v1.979h-5.6v2.313h4.946v1.918h-4.946v2.465h5.798zm8.75 1.979l-2.055-2.968h-2.267v2.968h-2.466V4.437h4.611c.944 0 1.76.158 2.45.472.7.315 1.238.761 1.614 1.34.375.578.563 1.263.563 2.054 0 .791-.193 1.476-.578 2.055-.376.568-.913 1.004-1.614 1.308l2.39 3.425H60.5zm-.046-6.788c0-.599-.193-1.055-.578-1.37-.386-.324-.949-.487-1.69-.487h-2.008v3.714h2.008c.741 0 1.304-.163 1.69-.487.385-.325.578-.781.578-1.37zm15.775 4.505h-4.946l-.944 2.283h-2.526l4.748-10.654h2.435l4.764 10.654h-2.587l-.944-2.283zm-.776-1.872l-1.69-4.079-1.689 4.079h3.38zm5.412-6.499h4.84c1.157 0 2.176.224 3.059.67.893.436 1.583 1.055 2.07 1.857.497.801.745 1.735.745 2.8 0 1.065-.248 1.999-.745 2.8-.487.802-1.177 1.426-2.07 1.872-.883.437-1.902.655-3.059.655h-4.84V4.437zm4.718 8.63c1.066 0 1.913-.295 2.542-.883.639-.599.959-1.405.959-2.42s-.32-1.816-.96-2.405c-.628-.598-1.475-.897-2.54-.897H83.33v6.605h2.252zm7.856-8.63h4.84c1.156 0 2.176.224 3.058.67.893.436 1.583 1.055 2.07 1.857.497.801.746 1.735.746 2.8 0 1.065-.249 1.999-.746 2.8-.487.802-1.177 1.426-2.07 1.872-.882.437-1.902.655-3.059.655h-4.84V4.437zm4.718 8.63c1.065 0 1.912-.295 2.541-.883.639-.599.959-1.405.959-2.42s-.32-1.816-.959-2.405c-.629-.598-1.476-.897-2.541-.897h-2.253v6.605h2.253zM112.8 15.09l-2.055-2.968h-2.267v2.968h-2.466V4.437h4.612c.943 0 1.76.158 2.45.472.7.315 1.238.761 1.613 1.34.375.578.563 1.263.563 2.054 0 .791-.193 1.476-.578 2.055-.376.568-.913 1.004-1.613 1.308l2.389 3.425H112.8zm-.046-6.788c0-.599-.193-1.055-.578-1.37-.386-.324-.949-.487-1.689-.487h-2.009v3.714h2.009c.74 0 1.303-.163 1.689-.487.385-.325.578-.781.578-1.37zm12.698 4.81v1.978h-8.248V4.437h8.05v1.979h-5.6v2.313h4.946v1.918h-4.946v2.465h5.798zm5.462 2.16a8.98 8.98 0 01-2.45-.335c-.781-.233-1.41-.532-1.887-.897l.837-1.857a5.67 5.67 0 001.628.807 6.116 6.116 0 001.887.304c.701 0 1.218-.102 1.553-.304.335-.214.502-.493.502-.838a.763.763 0 00-.304-.623 2.091 2.091 0 00-.761-.411 14.441 14.441 0 00-1.248-.335 17.298 17.298 0 01-1.994-.579 3.296 3.296 0 01-1.339-.928c-.365-.426-.548-.994-.548-1.704 0-.62.167-1.177.502-1.675.335-.507.837-.908 1.507-1.202.68-.294 1.506-.441 2.48-.441.68 0 1.345.081 1.994.243.65.163 1.218.396 1.705.7l-.761 1.872c-.984-.558-1.969-.837-2.953-.837-.69 0-1.202.112-1.537.335-.325.223-.487.518-.487.883s.188.639.563.822c.386.172.969.345 1.75.517.812.193 1.477.386 1.994.578.518.193.959.498 1.324.913.376.416.563.98.563 1.69 0 .609-.172 1.167-.517 1.674-.335.497-.842.893-1.522 1.187-.68.294-1.507.441-2.481.441zm9.705 0a8.98 8.98 0 01-2.45-.335c-.781-.233-1.41-.532-1.887-.897l.837-1.857a5.67 5.67 0 001.628.807 6.116 6.116 0 001.887.304c.701 0 1.218-.102 1.553-.304.335-.214.502-.493.502-.838a.763.763 0 00-.304-.623 2.091 2.091 0 00-.761-.411 14.441 14.441 0 00-1.248-.335 17.358 17.358 0 01-1.994-.579 3.296 3.296 0 01-1.339-.928c-.365-.426-.548-.994-.548-1.704 0-.62.167-1.177.502-1.675.335-.507.837-.908 1.507-1.202.68-.294 1.507-.441 2.481-.441.679 0 1.344.081 1.993.243.65.163 1.218.396 1.705.7l-.761 1.872c-.984-.558-1.969-.837-2.953-.837-.69 0-1.202.112-1.537.335-.324.223-.487.518-.487.883s.188.639.563.822c.386.172.969.345 1.75.517.812.193 1.477.386 1.994.578.518.193.959.498 1.324.913.376.416.563.98.563 1.69 0 .609-.172 1.167-.517 1.674-.335.497-.842.893-1.522 1.187-.68.294-1.507.441-2.481.441z",
    fill: "#C063D5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tutorial_3_svg__filter1_ii_116_9)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 23.553,
    width: 392,
    height: 67.217,
    rx: 5.073,
    fill: "#A24FB5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6F2F7D",
    stroke: "#6A2779",
    strokeWidth: 1.268,
    d: "M10.78 34.333h370.327V79.99H10.78z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tutorial_3_svg__filter2_d_116_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.556 63.595c-.982 0-1.935-.13-2.858-.391-.912-.272-1.646-.621-2.202-1.047l.977-2.167c.532.39 1.166.705 1.9.941a7.133 7.133 0 002.201.355c.817 0 1.42-.118 1.811-.355.39-.248.586-.574.586-.976a.892.892 0 00-.355-.728c-.225-.201-.52-.361-.888-.48-.355-.118-.84-.248-1.456-.39-.947-.225-1.722-.45-2.326-.675a3.846 3.846 0 01-1.562-1.083c-.426-.497-.64-1.16-.64-1.989 0-.722.196-1.373.587-1.953.39-.591.976-1.06 1.758-1.402.793-.344 1.757-.515 2.894-.515.793 0 1.568.094 2.326.284.757.19 1.42.462 1.988.817l-.888 2.184c-1.148-.651-2.296-.977-3.444-.977-.805 0-1.403.13-1.793.39-.38.261-.569.604-.569 1.03 0 .426.22.746.657.96.45.2 1.13.402 2.042.603.947.225 1.723.45 2.326.675.604.224 1.119.58 1.545 1.065.438.485.657 1.142.657 1.97a3.4 3.4 0 01-.604 1.954c-.39.58-.982 1.041-1.775 1.385-.794.343-1.758.515-2.895.515zm12.62-12.642c1.1 0 2.053.183 2.858.55.816.367 1.444.888 1.882 1.563.438.674.657 1.473.657 2.397 0 .911-.22 1.71-.657 2.397-.438.674-1.066 1.195-1.882 1.562-.805.355-1.758.533-2.859.533h-2.503v3.427h-2.877v-12.43h5.38zm-.16 6.658c.864 0 1.52-.183 1.97-.55.45-.38.675-.912.675-1.598 0-.699-.225-1.231-.675-1.598-.45-.38-1.106-.569-1.97-.569h-2.344v4.315h2.343zm15.171 3.107h-5.77l-1.101 2.664h-2.947l5.54-12.43h2.84l5.558 12.43h-3.019l-1.1-2.664zm-.905-2.184l-1.971-4.758-1.97 4.758h3.94zm12.089 5.06c-1.267 0-2.415-.272-3.445-.816a6.33 6.33 0 01-2.415-2.29c-.58-.983-.87-2.09-.87-3.32 0-1.232.29-2.333.87-3.303a6.158 6.158 0 012.415-2.29c1.03-.557 2.184-.835 3.463-.835 1.077 0 2.047.19 2.911.568.876.379 1.61.923 2.202 1.633l-1.846 1.705c-.84-.97-1.883-1.456-3.125-1.456-.77 0-1.456.172-2.06.515a3.597 3.597 0 00-1.42 1.403c-.332.603-.498 1.29-.498 2.06 0 .769.166 1.455.498 2.059a3.722 3.722 0 001.42 1.42c.604.332 1.29.497 2.06.497 1.242 0 2.284-.49 3.125-1.473l1.846 1.704a5.755 5.755 0 01-2.202 1.651c-.876.38-1.852.569-2.93.569zm16.697-2.52v2.308h-9.623v-12.43h9.392v2.309h-6.534v2.699h5.77v2.237h-5.77v2.876h6.765zm2.289-10.121h5.646c1.35 0 2.539.26 3.569.781 1.041.509 1.846 1.231 2.414 2.166.58.935.87 2.024.87 3.267 0 1.243-.29 2.332-.87 3.267-.568.935-1.373 1.663-2.414 2.184-1.03.51-2.22.764-3.57.764h-5.645v-12.43zM94.86 61.02c1.243 0 2.231-.343 2.965-1.03.746-.698 1.119-1.64 1.119-2.823 0-1.184-.373-2.119-1.119-2.805-.734-.699-1.722-1.048-2.965-1.048h-2.628v7.706h2.628zm18.788.053v2.309h-9.623v-12.43h9.392v2.309h-6.534v2.699h5.771v2.237h-5.771v2.876h6.765zm2.289-10.12h2.876v10.085h6.232v2.344h-9.108v-12.43zm12.128 2.343h-3.977v-2.343h10.831v2.343h-3.977v10.086h-2.877V53.297zm15.962 7.422h-5.77l-1.101 2.664h-2.947l5.539-12.43h2.841l5.558 12.43h-3.019l-1.101-2.664zm-.905-2.184l-1.971-4.758-1.971 4.758h3.942zm7.739 4.99c-.486 0-.894-.166-1.225-.498-.332-.331-.498-.745-.498-1.242 0-.51.166-.918.498-1.225.331-.32.739-.48 1.225-.48.485 0 .893.16 1.225.48.331.307.497.716.497 1.225 0 .497-.166.911-.497 1.242-.332.332-.74.498-1.225.498zm15.193-12.571v12.429h-2.361l-6.197-7.546v7.546h-2.841v-12.43h2.38l6.178 7.547v-7.546h2.841zm12.564 10.12v2.309h-9.623v-12.43h9.393v2.309h-6.534v2.699h5.77v2.237h-5.77v2.876h6.764zm4.864-7.776h-3.978v-2.344h10.831v2.343h-3.977v10.086h-2.876V53.297z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tutorial_3_svg__filter3_ii_116_9)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 160.524,
    width: 392,
    height: 67.217,
    rx: 5.073,
    fill: "#A24FB5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C778D8",
    stroke: "#BE77CE",
    strokeWidth: 1.268,
    d: "M10.78 171.304h370.327v45.657H10.78z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tutorial_3_svg__filter4_d_116_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.978 187.879h6.453c1.542 0 2.902.298 4.079.893 1.19.582 2.11 1.407 2.759 2.476.663 1.069.995 2.313.995 3.734 0 1.42-.332 2.665-.995 3.733-.649 1.069-1.569 1.901-2.759 2.496-1.177.582-2.537.873-4.079.873h-6.453v-14.205zm6.291 11.506c1.42 0 2.55-.392 3.388-1.177.853-.798 1.279-1.874 1.279-3.226 0-1.353-.426-2.422-1.279-3.207-.838-.798-1.968-1.197-3.388-1.197h-3.004v8.807h3.004zm17.353 2.942c-1.475 0-2.807-.318-3.998-.953a7.202 7.202 0 01-2.78-2.618c-.663-1.123-.994-2.381-.994-3.774 0-1.394.331-2.645.994-3.754a7.143 7.143 0 012.78-2.638c1.191-.636 2.523-.954 3.998-.954 1.474 0 2.8.318 3.977.954a7.143 7.143 0 012.78 2.638c.676 1.109 1.014 2.36 1.014 3.754 0 1.393-.338 2.651-1.014 3.774a7.202 7.202 0 01-2.78 2.618c-1.177.635-2.503.953-3.977.953zm0-2.8c.838 0 1.596-.189 2.272-.568a4.154 4.154 0 001.583-1.624c.392-.689.589-1.474.589-2.353 0-.88-.197-1.664-.589-2.354a4.004 4.004 0 00-1.583-1.603c-.676-.393-1.434-.589-2.272-.589-.839 0-1.597.196-2.273.589a4.144 4.144 0 00-1.603 1.603c-.379.69-.568 1.474-.568 2.354 0 .879.189 1.664.568 2.353.392.69.927 1.231 1.603 1.624.676.379 1.434.568 2.273.568zm23.269-11.648v14.205h-2.698l-7.082-8.624v8.624h-3.247v-14.205h2.719l7.062 8.624v-8.624h3.246zm14.359 11.567v2.638h-10.998v-14.205h10.735v2.638h-7.468v3.085h6.595v2.557h-6.595v3.287h7.731z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#tutorial_3_svg__filter5_ii_116_9)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 232.814,
    width: 392,
    height: 67.217,
    rx: 5.073,
    fill: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    stroke: "#E1E1E1",
    strokeWidth: 1.268,
    d: "M10.78 243.594h370.327v45.657H10.78z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#tutorial_3_svg__filter6_df_116_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.006 272.063c-1.076 0-2.05-.234-2.922-.7a5.338 5.338 0 01-2.039-1.964c-.487-.832-.731-1.77-.731-2.815s.249-1.984.746-2.816a5.233 5.233 0 012.039-1.948c.873-.477 1.847-.715 2.922-.715.873 0 1.669.152 2.389.457.721.304 1.33.745 1.827 1.324l-1.279 1.202c-.771-.832-1.719-1.248-2.846-1.248-.73 0-1.384.162-1.963.487a3.395 3.395 0 00-1.354 1.324c-.325.568-.487 1.212-.487 1.933 0 .72.162 1.364.487 1.933a3.506 3.506 0 001.354 1.339c.579.314 1.233.472 1.963.472 1.127 0 2.075-.421 2.846-1.264l1.279 1.218a4.844 4.844 0 01-1.842 1.324c-.72.304-1.517.457-2.389.457zm12.813-2.618h-5.327l-1.05 2.465h-2.039l4.794-10.653h1.948l4.809 10.653h-2.07l-1.065-2.465zm-.654-1.552l-2.009-4.657-1.994 4.657h4.003zm14.61-6.636v10.653h-1.628l-5.875-7.213v7.213h-1.963v-10.653h1.628l5.875 7.214v-7.214h1.963zm7.786 10.806c-1.076 0-2.05-.234-2.922-.7a5.34 5.34 0 01-2.04-1.964c-.487-.832-.73-1.77-.73-2.815s.248-1.984.745-2.816a5.236 5.236 0 012.04-1.948c.872-.477 1.846-.715 2.922-.715.872 0 1.669.152 2.389.457a4.855 4.855 0 011.826 1.324l-1.278 1.202c-.771-.832-1.72-1.248-2.846-1.248-.73 0-1.385.162-1.963.487a3.404 3.404 0 00-1.355 1.324c-.324.568-.487 1.212-.487 1.933 0 .72.163 1.364.487 1.933a3.515 3.515 0 001.355 1.339c.578.314 1.233.472 1.963.472 1.126 0 2.075-.421 2.846-1.264l1.278 1.218a4.848 4.848 0 01-1.841 1.324c-.72.304-1.517.457-2.389.457zm14.116-1.811v1.658h-7.99v-10.653h7.777v1.659h-5.798v2.77h5.144v1.628h-5.144v2.938h6.011zm2.206-8.995h1.978v8.979h5.57v1.674h-7.548v-10.653z",
    fill: "#F8F8F8"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tutorial_3_svg__clip0_116_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219 198v52.199h6.024v-3.071h-.003l.003-.002h3.012v-3.07h3.012v-3.071h3.012v6.141h3.056l-.044 6.143h3.012v3.07h6.024v-3.07h3.012v-6.141h-3.012l-.044-.002.044-6.141h-3.012v-3.07h12.049v-6.141h-3.012v.004l-.001-.004v-3.07h-3.012v-3.071h-3.012v-3.07h-3.012v-3.07h-3.012v-3.071h-3.012v-3.07h-3.012v-3.071h-3.012v-3.07h-3.012v-3.07h-3.012v-3.071h-3.012V198H219z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.012 204.141v42.985h3.012v-3.07h3.012v-3.071h3.012v-3.07h3.012v3.07h3.012v6.141h3.012v6.143h6.024v-6.141h-3.012v-6.143h-3.012v-6.141h12.048v-3.07h-3.012v-3.07h-3.012v-3.071h-3.012v-3.07h-3.012v-3.071h-3.012v-3.07h-3.012v-3.07h-3.012v-3.071h-3.012v-3.07h-3.012v-3.07h-3.012z",
    fill: "#EDEDED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tutorial_3_svg__filter0_d_116_9",
    x: 0.426,
    y: 4.255,
    width: 144.713,
    height: 12.287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.268
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_116_9"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_116_9",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tutorial_3_svg__filter1_ii_116_9",
    x: -7.609,
    y: 15.944,
    width: 407.219,
    height: 82.436,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.609,
    dy: -7.609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_116_9"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.609,
    dy: 7.609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_116_9",
    result: "effect2_innerShadow_116_9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tutorial_3_svg__filter2_d_116_9",
    x: 26.496,
    y: 50.74,
    width: 163.84,
    height: 15.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.536
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_116_9"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_116_9",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tutorial_3_svg__filter3_ii_116_9",
    x: -7.609,
    y: 152.914,
    width: 407.219,
    height: 82.436,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.609,
    dy: 7.609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_116_9"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.609,
    dy: -7.609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_116_9",
    result: "effect2_innerShadow_116_9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tutorial_3_svg__filter4_d_116_9",
    x: 165.978,
    y: 187.636,
    width: 61.273,
    height: 17.228,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.536
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_116_9"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_116_9",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tutorial_3_svg__filter5_ii_116_9",
    x: -7.609,
    y: 225.204,
    width: 407.219,
    height: 82.436,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.609,
    dy: 7.609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_116_9"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.609,
    dy: -7.609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_116_9",
    result: "effect2_innerShadow_116_9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tutorial_3_svg__filter6_df_116_9",
    x: 161.777,
    y: 258.568,
    width: 69.19,
    height: 16.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.536
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_116_9"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_116_9",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.268,
    result: "effect2_foregroundBlur_116_9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tutorial_3_svg__clip0_116_9"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(219 198)",
    d: "M0 0h36.145v58.339H0z"
  })))));
}
export default __webpack_public_path__ + "static/tutorial_3.54611007.svg";
export { SvgTutorial3 as ReactComponent };